import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SafeUrlPipe } from './safe-url.pipe';
import { StreamPipe } from './stream.pipe';
import { ImagePipe } from './image.pipe';
import { orderByPipe } from './order-by.pipe';
import { TextTruncatePipe } from './text-truncate.pipe';
import { BgCacheDirective, ImgCacheDirective } from './bg-cache.directive';
import { AsapCrudModule } from 'asap-crud';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AsapCrudModule
  ],
  declarations: [
    SafeUrlPipe,
    StreamPipe,
    ImagePipe,
    orderByPipe,
    TextTruncatePipe,
    BgCacheDirective,
    ImgCacheDirective
  ],
  exports: [
    AsapCrudModule,
    SafeUrlPipe,
    StreamPipe,
    ImagePipe,
    orderByPipe,
    TextTruncatePipe,
    BgCacheDirective,
    ImgCacheDirective
  ]
})

export class PipesModule { }
